import {
  Button,
  ModalBody,
  ModalHeader,
  ModalOverlay,
  Text,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import React from "react";
import { AppModal } from "../../../modals/AppModal";
import { AppModalContent } from "../../../modals/AppModalContent";
import { AppModalFooter } from "../../../modals/AppModalFooter";

export function AuthoriseConnectionModal({
  disclosure,
  onCancel,
  onContinue,
}: {
  disclosure: UseDisclosureReturn;
  onCancel: () => void;
  onContinue: () => void;
}): React.ReactElement {
  return (
    <AppModal
      isOpen={disclosure.isOpen}
      onClose={onCancel}
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />

      <AppModalContent>
        <ModalHeader>Connect data source</ModalHeader>
        {/* no close button is intentional, the user needs to complete OAuth */}

        <ModalBody>
          <Text color="gray.600">
            A secure connection window has opened. Continue there to finish
            connecting this data source.
          </Text>
        </ModalBody>

        <AppModalFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>

          <Button colorScheme="primary" onClick={onContinue}>
            Continue
          </Button>
        </AppModalFooter>
      </AppModalContent>
    </AppModal>
  );
}
